import { Toaster as SonnerToaster } from 'sonner'

export function Toaster() {
  return (
    <SonnerToaster
      theme="dark"
      position="top-right"
      richColors
      toastOptions={{
        style: {
          background: '#1a1a1a',
          border: '1px solid #D4AF37',
          color: '#ffffff',
        },
      }}
    />
  )
}